import { Link } from "@/i18n/routing";
import { Button } from "@repo/ui";

const ActionButtons = ({ t, isShippable, isRetry }) => (
  <div className="mt-6">
    <div className={isRetry ? "grid w-full grid-cols-2 gap-4" : ""}>
      <Link href="/">
        <Button
          variant={!isShippable ? "secondary" : "primary"}
          className="w-full"
          size="md"
        >
          {t("Take_Me_Home")}
        </Button>
      </Link>

      {isRetry && (
        <Link href="/checkout">
          <Button variant="primary" className="w-full" size="md">
            {t("Retry_Payment")}
          </Button>
        </Link>
      )}
    </div>
  </div>
);

export default ActionButtons;
